import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
const PageTitle = ({ children, className, }) => _jsx("h1", { className: classNames("page-title", className), children: children });
export default PageTitle;
